import React from 'react';

export default function OperatorSimulator(props) {

    const changeActifOperator = () => {
        let name = document.querySelector('#actifOperator').value;
        if (name !== "Operator choice") {
            props.dispatch({
                type: 'change_active_operator',
                payload: {
                    active_operator_display: true,
                    active_operator_id: name.substr(0, name.indexOf(" / ")),
                    active_operator_pseudo: name.substr(name.indexOf(" / ") + 3, name.indexOf(" - ") - 4),
                    active_operator_name: name.substr(name.indexOf(" - ") + 3),
            }})
        } else {
            props.dispatch({
                type: 'change_active_operator',
                payload: {
                    active_operator_display: false,
                    active_operator_id: 0,
                    active_operator_pseudo: '',
                    active_operator_name: '',
            }})
        }
    };
    
    return (
        <div className="showOperator">
            {props.state && props.state.active_operator_display && (
                <p className="dispOperator">{props.state.active_operator_name}</p>
            )}
            <select
                className="operatorChoiceSelector"
                id="actifOperator"
                onChange={() => changeActifOperator()}
                style={{textAlign: 'center'}}>
                <option key={"operatorChoice"}>Operator choice</option>
                {props.state.operator_list.length > 0
                    && props.state.operator_list.map((operator, index) => (
                    <option
                        key={"operator" + index}
                        value={operator.id + " / "
                            + operator.operator_pseudo + " - " +
                            operator.operator_firstname + " " +
                            operator.operator_lastname}>
                        { operator.operator_pseudo}
                    </option>
                ))}
            </select>
        </div>
    )
}